import { render } from "./SubContent.vue?vue&type=template&id=f556214e"
import script from "./SubContent.vue?vue&type=script&lang=js"
export * from "./SubContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__